import { mapValues, keyBy } from 'lodash'

export const initialValueForMultiLangSupport = supportedLangs =>
  mapValues(keyBy(supportedLangs), () => '')



// WEBPACK FOOTER //
// ./src/modules/form/index.js